import React, { useState, useRef, useEffect } from "react";
import AssignProductSelectComponent from "./giftSelect.component";
import AssignProductPanelComponent from "./giftSelectPanel.component";
import PropTypes from "prop-types";
import { selectLoading } from "modules/notification";
import { useDispatch, useSelector } from "react-redux";
import { getGiftDropdown } from "modules/loyalty-program/redux"
import { getLang } from "app/feature/constants";

function ModuleSelectContainer({
  placeholder,
  handleChange,
  value,
  disabled
}) {
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [search, setSearch] = useState("")
  const dispatch = useDispatch();
  const giftDropdown = useSelector(
    (state) => state.redemptionCenter.giftDropdown
  );
  const isGiftDropdownLoading = useSelector((state) =>
    selectLoading(state, getGiftDropdown.typePrefix)
  );
  const lang = useSelector(state => state.constant.languages)

  useEffect(() => {
    dispatch(getGiftDropdown({
      search: search
    }));
  }, [dispatch, search]);

  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleSearch = async (values) => {
    await setSearch(values)
  }

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  function handleListKeyDown(v) {
    const temp = value.slice();
    const index = temp.findIndex(
      (t) => t.id === v.id
    );
    if (index === -1) {
      temp.push(v);
    } else {
      temp.splice(index, 1);
    }
    handleChange(temp);
  }

  return (
    <>
      <AssignProductSelectComponent
        anchorRef={anchorRef}
        handleClick={handleClick}
        value={value}
        placeholder={getLang(lang, 'placeholder.SELECT_GIFT')}
        disabled={disabled}
        lang={lang}
      />
      <AssignProductPanelComponent
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isGiftDropdownLoading}
        handleListKeyDown={handleListKeyDown}
        productDropdown={giftDropdown}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

ModuleSelectContainer.propTypes = {
  placeholder: PropTypes.string
};


export default (ModuleSelectContainer);
